import React, { useState } from "react";
import Input from "./input";
import Enter from "./enter";
import { useNavigate } from "react-router-dom";

const VerifyEmail = () => {
    const navigate = useNavigate();
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);
    const [text, setText] = useState("Send verification email");
    const [form, setForm] = useState({
        primaryEmail: ""
    });

    // have a useEffect to check whether or not user is logged in and if they are then reroute them to their role-based sub domain
    
    function updatePrimaryEmail(primaryEmail) {
        setForm(prevFrom => ({
            ...prevFrom,
            primaryEmail: primaryEmail,
        }))
    }

    function submitForm(e) {
        e.preventDefault();

        for (const value in form) {
            if (form[value] === "") {
                setText("Please enter an email")
                return;
            }
        }

        // Additional email validation checks
        if (!form.primaryEmail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            setText("Invalid email format");
            return;
        }

        startEmailVerificationProcess();
        
    }

    const startEmailVerificationProcess = async () => {
        if (requestLifeCycle) {
            return;
        }
        
        const url = process.env.REACT_APP_USER_API_URL + "/create-verfication-email";

        const urlOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ email: form.primaryEmail })
        }

        try {
            setRequestLifeCycle(true);
            const res = await fetch(url, urlOptions);
            const data = await res.json();
            if (res.status === 200) {
                navigate(`/confirm-email/${form.primaryEmail}/`);
            } else if (res.status === 400) {
                setText("Email address is already verified");
                navigate("/login");
            } else if (res.status === 405) {
                setText(data.detail);
            } else {
                setText("Status Code: " + res.status + " Error: " + data.detail)
            }

        } catch (error) {
            setText("Error: " + error.message);
            console.log(error);
        } finally {
            setRequestLifeCycle(false);
        }
    }

    return (
        <>
            <div className="signup-container">
                <div className="add-a-course-form-container">
                    <div className="add-a-course-form-content-container">
                        <form className="form-width">
                            <div className="add-course-title">
                                Email Verification
                            </div>
                            <div className="account-settings-content">
                                <div className="required-container">
                                    All Fields Required
                                </div>   
                                <div className="banner top">
                                    Enter your account email address
                                </div>
                                <Input top={"Email Address"} require={true} value={form.primaryEmail} updateValue={updatePrimaryEmail} placeholder={"johndoe@university.edu"} autoComplete={"email"} type={"text"}/>
                                <div className="forgot-verify" style={{ justifyContent: "flex-end" }}>
                                    <span className="actions" onClick={() => {
                                        navigate("/login")
                                    }}> Log In? </span>
                                </div>
                                <Enter requestLifeCycle={requestLifeCycle} submitForm={submitForm} text={text}/>
                            </div>
                        </form> 
                    </div>
                </div>
            </div>
        </>
    );
}

export default VerifyEmail;